import API from '../../api';
import { toast } from 'react-toastify';

const API_URL = '/api/customers';

const resetPasswordForgot = async (data, token, navigate, setLoading) => {
  try {
    const response = await API.post(`${API_URL}/reset-password`, {
      token: token,
      ...data
    });
    setLoading(false);
    toast.success('Password updated successfully');
    setTimeout(() => {
      navigate('/');
    }, 2000);
  } catch (error) {
    setLoading(false);
    toast.error(error?.response?.data?.error?.message ?? error?.message);
  }
};

export default resetPasswordForgot;
